import { render } from "./KoiListItem.vue?vue&type=template&id=3e1aece3&scoped=true&ts=true"
import script from "./KoiListItem.vue?vue&type=script&lang=ts"
export * from "./KoiListItem.vue?vue&type=script&lang=ts"

import "./KoiListItem.vue?vue&type=style&index=0&id=3e1aece3&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e1aece3"]])

export default __exports__